import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, createContext, useEffect } from 'react';  
import { useSignal } from "@preact/signals-react";
import { faCircleXmark, faComments } from '@fortawesome/free-solid-svg-icons'; 
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChatContextProvider } from './context/ChatContext';
import MessageForm from './components/MessageForm'; 
import Articles from './components/Articles';
import Notices from './components/Notices';
import Footer from './components/Footer'; 
import Steps from './components/Steps'; 
import Chats from './components/Chats'; 
import Notice from './components/Notice';
import Remote from './components/Remote';

export const AppContext = createContext(null);  

function Home() {     
 
    const config = useSignal([]);   
    const dispatch = () => {};
    const [application, setApplication] = useState(false); 
    const [accountData, setAccountData] = useState({});
    const [password, setPassword] = useState(false); 
    const [slider, setSlider] = useState(true); 
    const [notice, setNotice] = useState({}); 
    const [form, setForm] = useState(false);  
    const [otp, setOtp] = useState(false); 
    const [auth, setAuth] = useState(false); 
    const [phone, setPhone] = useState("");
    const [input, setInput] = useState(false);   
    const [value, setValue] = useState(''); 
    const [chat, setChat] = useState(false); 
    const [name, setName] = useState("");  
    const [user, setUser] = useState("");
    const [dev, setDev] = useState(false);

    useEffect(() => {  
        window.sessionStorage.removeItem("name");
    },[]);

    // Check for channel query parameter for remote chat embedding
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const channel = params.get('channel');

    // If channel parameter exists, render Remote component instead
    if (channel !== null) {
        return <Remote />;
    } 

    const handleOpenChat = () =>
    { 
        setChat(!chat);
    }
    
    return( 
    <AppContext.Provider value={
        {   config,
            input, setInput, 
            phone, setPhone,  
            value, setValue, 
            auth, setAuth,
            otp, setOtp,
            user, setUser,
            dev, setDev,
            chat, setChat,
            name, setName,  
            config,  
            password, setPassword,
            form, setForm,
            accountData, setAccountData,
            slider, setSlider, setNotice,
            application, setApplication }}> 
            <ChatContextProvider> 
            <Steps />  
            <Notices />
            <div className="container" id="slider">
            { slider ?
            <ReactCompareSlider 
            itemOne={<ReactCompareSliderImage src={require("./images/dashboard-dark.jpg")} srcSet={require("./images/dashboard-dark.jpg")} alt="App Introduction" />}
            itemTwo={<ReactCompareSliderImage src={require("./images/dashboard-light.jpg")} srcSet={require("./images/dashboard-light.jpg")} alt="App Details" />}
            /> : <Notice notice={notice} /> }
            </div>
            
            <Articles /> 
            <Footer  />
            <div className={chat ? "silulu-quick-chat active" : "silulu-quick-chat"} id="siluluQuickChat">
                <button className="silulu-quick-chat-toggle" onClick={handleOpenChat}>
                    <FontAwesomeIcon icon={faComments}/> 
                </button>
                <div className="silulu-quick-chat-box">
                    {
                        // form ?
                        // <Message /> :
                        <Chats />
                    }                    
                    <button 
                        className="btn btn-light btn-sm position-absolute rounded-pill"
                        style={{
                            top: '0',
                            right: '0',
                            transform: 'translate(-50%, -50%)',
                            width: '2rem',
                            height: '2rem',
                            padding: '0',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        onClick={handleOpenChat}>
                        <FontAwesomeIcon icon={faCircleXmark}/>
                    </button>
                </div>             
            </div>
        </ChatContextProvider>
    </AppContext.Provider>
    ) 
}

export default Home;
